var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.commentLoading,
          expression: "commentLoading",
        },
      ],
      staticClass: "reply-comment",
    },
    [
      !_vm.showNoFocus
        ? [
            _c("el-input", {
              attrs: {
                rows: 3,
                maxlength: 2000,
                "show-word-limit": "",
                type: "textarea",
                placeholder: "请输入回复内容",
              },
              on: { blur: _vm.blurFun },
              model: {
                value: _vm.commentsTextarea,
                callback: function ($$v) {
                  _vm.commentsTextarea = $$v
                },
                expression: "commentsTextarea",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btn-group" },
              [
                _c(
                  "el-popover",
                  {
                    attrs: { placement: "top", width: "400", trigger: "click" },
                    model: {
                      value: _vm.showEmoji,
                      callback: function ($$v) {
                        _vm.showEmoji = $$v
                      },
                      expression: "showEmoji",
                    },
                  },
                  [
                    _c("emoji", { on: { select: _vm.selectEmoji } }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "wk wk-expression smiling-img",
                      attrs: { slot: "reference" },
                      slot: "reference",
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-box" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.commentSubmit },
                      },
                      [_vm._v("回复")]
                    ),
                    _vm._v(" "),
                    _c("el-button", { on: { click: _vm.closeComment } }, [
                      _vm._v("取消"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _c(
            "div",
            {
              staticClass: "no-focus",
              on: {
                click: function ($event) {
                  return _vm.toggleFocus()
                },
              },
            },
            [_vm._v("\n    请输入回复内容\n  ")]
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }